import * as React from 'react';

import KeynoteForMac32 from './KeynoteForMac32';

export const keynoteForMac32 = () => <KeynoteForMac32 />;

export default {
    title: 'Icon/Logo/KeynoteForMac32',
    component: KeynoteForMac32,
    parameters: {
        notes: "`import KeynoteForMac32 from 'box-ui-elements/es/icon/logo/KeynoteForMac32';`",
    },
};
